import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import {
  Form,
  Button,
  Accordion,
  Card,
} from "react-bootstrap";
import { css } from "aphrodite";
import styles from "../style";
import CustomRadioButton from "../../GenericComponents/CustomRadioButton";
import CustomModal from "../../GenericComponents/CustomModal";
import CustomAccordion from "../../GenericComponents/CustomAccordion";
import LowHRThresholdCard from "./LowHRThresholdCard";
import HighHRThresholdCard from "./HighHRThresholdCard";
import DeviceAlarmSelect from "../DeviceAlarmSelect";
import "./HRMSettings.css";
import { DeviceForAlarmRingTone } from "../../../lib/constant";

class HRMSettings extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      allowSettingChangeOnSmartWatch: false,
      allowSnoozeOnSmartWatch: false,
      enableHRMAlarmRingtone: false,
      enableUpdateFlag: false,
      updateSettings: false,
      enableHRMonitoring: false,
    };
  }

  componentDidMount = () => {

  };

  handleSliderValues = (fieldName, value) => {
    let hrmSettings = this.props.hrmSettings;
    hrmSettings[fieldName] = value;
    this.setState({ enableUpdateFlag: true }, () => {
      this.props.setHRMSettingsData(hrmSettings);
    });
  };

  handleChanges = (fieldName, value) => {
    let hrmSettings = this.props.hrmSettings;
    hrmSettings[fieldName] = value.target.checked;
    this.setState(
      { enableUpdateFlag: true, [fieldName]: value.target.checked },
      () => {
        this.props.setHRMSettingsData(hrmSettings);
      }
    );
  };

  handleSettingChanges = (fieldName, value) => {
    let hrmSettings = this.props.hrmSettings;
    hrmSettings[fieldName] = value;
    this.setState({ enableUpdateFlag: true, [fieldName]: false }, () => {
      this.props.setHRMSettingsData(hrmSettings);
    });
  };

  saveData = () => {
    this.setState({ updateSettings: !this.state.updateSettings });
  };

  handleUpdate = (fieldName, value) => {
    this.setState({ updateSettings: !this.state.updateSettings }, () => {
      value &&
        this.props.updateHRMSettings(
          this.props.hrmSettings
        );
    });
  };

  resetLowHRThresholdSettings = () => {
    let hrmSettings = { ...this.props.hrmSettings };
    hrmSettings.lowHRThreshold =
      parseInt(this.props.defaultSettings.LOW_HR_THRESHOLD.defaultValue);

    this.setState({ enableUpdateFlag: true }, () => {
      this.props.setHRMSettingsData(hrmSettings);
    });
  };

  resetHighHRThresholdSettings = () => {
    let hrmSettings = { ...this.props.hrmSettings };
    hrmSettings.highHRThreshold =
      parseInt(this.props.defaultSettings.HIGH_HR_THRESHOLD.defaultValue);

    this.setState({ enableUpdateFlag: true }, () => {
      this.props.setHRMSettingsData(hrmSettings);
    });
  };

  resetHRThresholdDurationSettings = () => {
    let hrmSettings = { ...this.props.hrmSettings };
    hrmSettings.hrThresholdDuration =
      parseInt(this.props.defaultSettings.HR_THRESHOLD_DURATION.defaultValue);

    this.setState({ enableUpdateFlag: true }, () => {
      this.props.setHRMSettingsData(hrmSettings);
    });
  };

  render() {
    const { hrmSettings, defaultSettings, appModules, user } = this.props;
    const isReadOnly = user?.roleId === 10;

    return (
      <container>
        <CustomModal
          header={"Alert"}
          name={"enableHRMonitoring"}
          size={"sm"}
          title={
            "Are you sure to enable the Heart Rate Monitoring?"
          }
          show={this.state.enableHRMonitoring}
          action={this.handleSettingChanges}
        />
        <CustomModal
          header={"Alert"}
          name={"allowSettingChangeOnSmartWatch"}
          size={"sm"}
          title={
            "Are you sure to enable the Allow Setting Change On Smartwatch"
          }
          show={this.state.allowSettingChangeOnSmartWatch}
          action={this.handleSettingChanges}
        />
        <CustomModal
          header={"Alert"}
          name={"allowSnoozeOnSmartWatch"}
          size={"sm"}
          title={
            "Are you sure to enable the Allow Snooze trun On/Off On Smartwatch"
          }
          show={this.state.allowSnoozeOnSmartWatch}
          action={this.handleSettingChanges}
        />
        <CustomModal
          header={"Alert"}
          name={"enableHRMAlarmRingtone"}
          size={"sm"}
          title={"Are you sure to Enable Alarm Ringtone For HR Threshold"}
          show={this.state.enableHRMAlarmRingtone}
          action={this.handleSettingChanges}
        />
        <CustomModal
          header={"Confirm"}
          name={"updateSettings"}
          size={"sm"}
          title={"Are you sure you want to save the details ?"}
          show={this.state.updateSettings}
          action={this.handleUpdate}
        />
        <div className="monitoring-settings-content">
          <div className={css(styles.header)}>{"Heart Rate Monitoring"}</div>
          {appModules.active.HRM ? (
            <Form>
              <Form.Group className={css(styles.formGroupStyles)}>
                <Form.Label className={css(styles.settingLabels)}>
                  Enable Heart Rate Monitoring
                </Form.Label>

                <CustomRadioButton
                  name={"enableHRMonitoring"}
                  type={"switch"}
                  inline={true}
                  label={""}
                  checked={hrmSettings.enableHRMonitoring}
                  action={this.handleChanges}
                />
              </Form.Group>
              <Form.Group className={css(styles.formGroupStyles)}>
                <Form.Label
                  className={
                    user.entityMaster?.shortName === "SM" ||
                    user.entityMaster?.shortName === "SIH"
                      ? css(styles.disabledLabels)
                      : css(styles.settingLabels)
                  }
                >
                  Allow settings change on smartwatch
                </Form.Label>

                <CustomRadioButton
                  name={"allowSettingChangeOnSmartWatch"}
                  type={"switch"}
                  inline={true}
                  label={""}
                  checked={hrmSettings.allowSettingChangeOnSmartWatch}
                  action={this.handleChanges}
                  disabled={
                    user.entityMaster?.shortName === "SM" ||
                    user.entityMaster?.shortName === "SIH" ||
                    isReadOnly
                  }
                />
              </Form.Group>

              <Form.Group className={css(styles.formGroupStyles)}>
                <Form.Label className={css(styles.settingLabels)}>
                  Allow snooze turn on/off on smartwatch <br />
                </Form.Label>

                <CustomRadioButton
                  name={"allowSnoozeOnSmartWatch"}
                  type={"switch"}
                  inline={true}
                  label={""}
                  checked={hrmSettings.allowSnoozeOnSmartWatch}
                  action={this.handleChanges}
                  disabled={isReadOnly}
                />
              </Form.Group>
              <Form.Group className={css(styles.formGroupStyles)}>
                <Form.Label className={css(styles.settingLabels)}>
                  Audible Alarm
                </Form.Label>
                <DeviceAlarmSelect
                  aria-label="Select device type"
                  value={
                    hrmSettings.deviceForAlarmRingTone ||
                    DeviceForAlarmRingTone.none
                  }
                  onChange={(val) =>
                    this.handleSettingChanges("deviceForAlarmRingTone", val)
                  }
                  disabled={isReadOnly}
                />
              </Form.Group>
              <Accordion defaultActiveKey="0" flush>
                <Card style={{ marginBottom: "1em" }}>
                  <Card.Header className={css(styles.cardHeaderStyle)}>
                    <Form.Group className={css(styles.formGroupStylesNew)}>
                      <Form.Label className={css(styles.settingLabels, styles.settingCardLabels)}>
                        Low HR Threshold <br />
                        <span className={css(styles.subLabels)}>
                          Low HR Threshold event will trigger whenever your
                          heart rate/min drops below the Low HR value set below.
                        </span>
                        <br />
                        <span
                          style={{
                            fontSize: "14px",
                            color: "#76787a",
                            textTransform: "initial",
                          }}
                        >
                          Set for{" "}
                          {`${hrmSettings.lowHRThreshold} ${defaultSettings.LOW_HR_THRESHOLD.unit}`}
                        </span>
                        <br />
                        <span
                          style={{
                            fontSize: "14px",
                            color: "#76787a",
                            textTransform: "initial",
                          }}
                        >
                          Duration for low HR alert set for{" "}
                          {`${hrmSettings.lowHRThresholdDuration} ${defaultSettings.LOW_HR_THRESHOLD_DURATION.unit}`}
                        </span>
                      </Form.Label>
                      {!isReadOnly && (
                        <div className={css(styles.settingActionButtons)}>
                          <div style={{ marginBottom: "10px" }}>
                            <CustomAccordion eventKey="edit-btn1">
                              <Button
                                //variant="secondary"
                                type="button"
                                id="edit-btn1"
                                className="editButtonStyles"
                              >
                                Edit
                              </Button>
                            </CustomAccordion>
                          </div>
                          <div>
                            <Accordion.Collapse eventKey="edit-btn1">
                              <Button
                                variant="primary"
                                type="button"
                                className="editButtonStyles"
                                onClick={() =>
                                  this.resetLowHRThresholdSettings()
                                }
                              >
                                Reset to Defaults
                              </Button>
                            </Accordion.Collapse>
                          </div>
                        </div>
                      )}
                    </Form.Group>
                  </Card.Header>
                  <Accordion.Collapse eventKey="edit-btn1">
                    <Card.Body>
                      <LowHRThresholdCard
                        lowHRSettings={hrmSettings}
                        defaultSettings={defaultSettings}
                        handleSliderValues={this.handleSliderValues}
                      />
                    </Card.Body>
                  </Accordion.Collapse>
                </Card>

                <Card style={{ marginBottom: "1em" }}>
                  <Card.Header className={css(styles.cardHeaderStyle)}>
                    <Form.Group className={css(styles.formGroupStylesNew)}>
                      <Form.Label className={css(styles.settingLabels, styles.settingCardLabels)}>
                        High HR Threshold <br />
                        <span className={css(styles.subLabels)}>
                          High HR Threshold event will trigger whenever your
                          heart rate/min rises above the High HR value set
                          below.
                        </span>
                        <br />
                        <span
                          style={{
                            fontSize: "14px",
                            color: "#76787a",
                            textTransform: "initial",
                          }}
                        >
                          Set for{" "}
                          {`${hrmSettings.highHRThreshold} ${defaultSettings.HIGH_HR_THRESHOLD.unit}`}
                        </span>
                        <br />
                        <span
                          style={{
                            fontSize: "14px",
                            color: "#76787a",
                            textTransform: "initial",
                          }}
                        >
                          Duration for high HR alert set for{" "}
                          {`${hrmSettings.highHRThresholdDuration} ${defaultSettings.HIGH_HR_THRESHOLD_DURATION.unit}`}
                        </span>
                      </Form.Label>
                      {!isReadOnly && (
                        <div className={css(styles.settingActionButtons)}>
                          <div style={{ marginBottom: "10px" }}>
                            <CustomAccordion eventKey="edit-btn2">
                              <Button
                                //variant="secondary"
                                type="button"
                                id="edit-btn2"
                                className="editButtonStyles"
                              >
                                Edit
                              </Button>
                            </CustomAccordion>
                          </div>
                          <div>
                            <Accordion.Collapse eventKey="edit-btn2">
                              <Button
                                variant="primary"
                                type="button"
                                className="editButtonStyles"
                                onClick={() =>
                                  this.resetHighHRThresholdSettings()
                                }
                              >
                                Reset to Defaults
                              </Button>
                            </Accordion.Collapse>
                          </div>
                        </div>
                      )}
                    </Form.Group>
                  </Card.Header>
                  <Accordion.Collapse eventKey="edit-btn2">
                    <Card.Body>
                      <HighHRThresholdCard
                        highHRSettings={hrmSettings}
                        defaultSettings={defaultSettings}
                        handleSliderValues={this.handleSliderValues}
                      />
                    </Card.Body>
                  </Accordion.Collapse>
                </Card>
              </Accordion>

              <div style={{ marginTop: "2em", textAlign: "center" }}>
                {!isReadOnly && (
                  <Button
                    variant="primary"
                    type="button"
                    className={css(styles.updateButtonStyles)}
                    style={{ marginRight: "10px" }}
                    disabled={!this.state.enableUpdateFlag}
                    onClick={() => this.saveData()}
                  >
                    Update
                  </Button>
                )}
                <Button
                  variant="secondary"
                  type="button"
                  className={css(styles.updateButtonStyles)}
                  onClick={() => this.props.closeSettings()}
                >
                  Close
                </Button>
              </div>
            </Form>
          ) : (
            <div
              style={{
                fontSize: "16px",
                textTransform: "capitalize",
                color: "red",
              }}
            >
              <label>Not included in your current subscription plan</label>
            </div>
          )}
        </div>
      </container>
    );
  }
}

export default connect(
  (store) => {
    return {
      hrmSettings: store.settings.hrmSettings,
      appModules: store.dashboard.appModules,
      user: store.user
    };
  },
  (dispatch) => {
    return {};
  }
)(withRouter(HRMSettings));
